/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Edit_MetadataInputs */



/**
* | output |
* | --- |
* | "Edit Metadata" |
*
* @param {Event_Group_Options_Edit_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_edit_metadata = /** @type {((inputs?: Event_Group_Options_Edit_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Edit_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier les métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータの編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar metadados")
	return /** @type {LocalizedString} */ ("Edit Metadata")
});